// extracted by mini-css-extract-plugin
export default {"plainAnchor":"nestedMenuItem_plainAnchor__rRquu"};